export { CurrencyEuro as default } from './CurrencyEuro';
